// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import axios from 'axios';
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
import SlideVerify from 'vue-monoplasty-slide-verify';
import store from './store';
import 'bootstrap/dist/css/bootstrap.css'

import 'lib-flexible'

Vue.use(ElementUI);
Vue.use(SlideVerify)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js